export const otRouteDef = [
    {
        path: 'ot_slots',
        component: 'OtSlotsComponent',
        data: {
            selector: 'kx-ot-slots',
            //resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: 'ot_transport',
        component: 'OtTransportDetailsComponent',
        data: {
            selector: 'app-ot-transport-details',
        }
    },
    {
        path: "ot_template",
        component: 'OtTemplateViewComponent', 
        data: {
            selector: 'kx-ot-template-view',
            resource: 'ot_template'
        }
    },
    {
        path:':resource/:returnId/:resource/opdetail',
        component:'DynamicGridWithControlsComponent',
        data : {
            selector: 'kx-editable-grid'
        }
    },
    {
        path: 'clearance_status_ot',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: 'clearance_status_cathlab',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: ':resource/patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
        }
    },
    {
        path: ':id/:resource/otTrack',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource:'ot_track_details'
        }
    },
    {
        path: ':id/:title/:type/event-calendar',
        component: 'EventCalendarComponent',
        data: {
            selector: 'kx-event-calendar'
        }
    },
    {
        path: ':type/ot-dashboard',
        component: 'EventCalendarComponent',
        data: {
            selector: 'kx-event-calendar',
            type:'calendar_event_ot'
        }
    },
    {
        path: 'surgery_authorization/list',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'surgery_authorization',
            action: "LIST"
        }
    },
    {
        path: ':id/:resource/cathlabTrack',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
            resource:'cathlab_tracker_details'
        }
    },
]


